import makeInspectable from 'mobx-devtools-mst'
import { Provider } from 'mobx-react'
import * as React from 'react'
import Helmet from 'react-helmet'
import TopLevelError from '../components/TopLevelError'
import './index.scss'

import { PlayerStore } from '../models/player'
import { RootStore } from '../models/root'
import { ScriptStore } from '../models/script'

const rootStore = RootStore.create({
  player: PlayerStore.create(),
  script: ScriptStore.create()
})

if (process.env.NODE_ENV !== `production`) {
  makeInspectable(rootStore)
}

interface IProps {
  children: () => {}
}

const Layout: React.StatelessComponent<IProps> = props => {
  return (
    <Provider store={rootStore}>
      <div className="app">
        <Helmet
          defaultTitle={'Supportive - Guided Audio Conversations for Pairs'}
          titleTemplate={`%s - Supportive`}
        />
        <div className="beta" />
        <TopLevelError />
        {props.children()}
        <footer className="footer">
          <div className="footer__content">
            <span className="tiny_subtext">
              <img
                className="footer__logo"
                src={require('../img/logo__bw.svg')}
                alt=""
              />
              &copy; 2018
            </span>
          </div>
        </footer>
      </div>
    </Provider>
  )
}

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.tsx